import { useEffect, useState } from "react";
import { TCohort } from "../Types/CohortType";
import { Api } from "../Services/CohortServices";
import { MainContainer } from "../Components/MainContainer";
import { SearchBarComponent } from "../Components/SearchBarComponent";
import { Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { FormatDate } from "../Utils/FormatDate";
import { FormatCurrency } from "../Utils/FormatCurrency";
import { ToasterAdviser } from "../Components/ToasterComponent";

export const Cohorts = () => {
  const [cohorts, setCohorts] = useState<TCohort[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [filteredCohort, setFilteredCohort] = useState<TCohort[]>([]);
  const [selectedCohort, setSelectedCohort] = useState<TCohort | null>(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [success, setSuccess] = useState<string | null>(null);
  const [cohortToastedId, setCohortToastedId] = useState<string | null>(null);
  const navigate = useNavigate();
  const { bool } = useParams();

  const fetchCohorts = async () => {
    setLoading(true);
    try {
      const response = await Api.get(`/cohorts`);
      setCohorts(response.data.cohorts);
    } catch (error) {
      setError("Não houve retorno do servidor, tente novamente mais tarde.");
    }
    finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const controller = new AbortController();
    if (filteredCohort && filteredCohort.length === 0) {
      fetchCohorts();
    }
    return () => {
      controller.abort();
    };
    // eslint-disable-next-line
  }, [bool]);

  const deleteModal = (cohort: TCohort) => {
    setSelectedCohort(cohort);
    setConfirmDelete(true)
  }

  const handleDelete = async (cohortId: number) => {
    try {
      await Api.delete(`/cohorts/${cohortId}`);
      setCohortToastedId(cohortId.toString());
      setSuccess("Cohort deletado com sucesso!");
      setTimeout(() => {
        setSuccess(null);
        setError(null);
        setCohortToastedId(null);
        setCohorts((prev) => prev.filter((cohort) => cohort.id !== cohortId));
      }, 3000);
    } catch (error) {
      console.error("Erro ao deletar o cohort:", error);
      setError("Erro ao deletar o cohort. Tente novamente mais tarde.");
      setTimeout(() => {
        setSuccess(null);
        setError(null);
        setCohortToastedId(null);
      }, 3000);
    }
  }

  const handleCohortById = (cohortId: number) => {
    navigate(`/cohorts/${cohortId}`);
  }

  const listaFinal = (filteredCohort && filteredCohort.length > 0) ? filteredCohort : cohorts;

  return (
    <MainContainer>
      <>
        <div className="main-content">
          <div className="mt-1">
            <Col md={12}>
              <div style={{ fontSize: '2.25rem ', fontWeight: '900 ', color: '#000' }}>Cohorts Cadastrados</div>
              <SearchBarComponent<TCohort>
                searchPlaceholder="Pesquisar por Tag"
                buttonName="Criar Cohort"
                buttonRoute="/createcohort"
                setFilteredClient={setFilteredCohort}
                isLoading={setLoading}
              />
              {loading ? (
                <p className="d-flex align-items-center mt-4">Carregando...</p>
              ) : error ? (
                <p style={{ color: "red", marginTop: "1rem" }}>{error}</p>
              ) : (
                <div
                  style={{
                    backgroundColor: "inherit",
                    maxHeight: "70%",
                    borderRadius: "0.8rem",
                    padding: "0.5rem",
                    marginTop: "1.5rem",
                    overflowY: "auto",
                  }}
                >
                  {listaFinal && listaFinal.length > 0 ? (
                    listaFinal.map((cohort) => {
                      const atributos = [
                        {
                          label: "Liberado Consulta",
                          value:
                            cohort.liberado_consulta === null
                              ? null
                              : cohort.liberado_consulta === true
                                ? "Sim"
                                : "Não",

                        },
                        {
                          label: "Possui Saldo",
                          value:
                            cohort.possui_saldo === null
                              ? null
                              : cohort.possui_saldo === true
                                ? "Sim"
                                : "Não",
                        },
                        {
                          label: "Proposta Cadastrada",
                          value:
                            cohort.proposta_cadastrada === null
                              ? null
                              : cohort.proposta_cadastrada === true
                                ? "Sim"
                                : "Não",
                        },
                        {
                          label: "Reposição Saldo",
                          value:
                            cohort.reposicao_saldo === null
                              ? null
                              : cohort.reposicao_saldo === true
                                ? "Sim"
                                : "Não",
                        },
                        {
                          label: "Saque Concorrente",
                          value:
                            cohort.saque_concorrente === null
                              ? null
                              : cohort.saque_concorrente === true
                                ? "Sim"
                                : "Não",
                        },
                        {
                          label: "Qtd Compras",
                          value: cohort.qtd_compras === null ? null : cohort.qtd_compras,
                          condition: cohort.condition_qtd_compras ? cohort.condition_qtd_compras === "greater" ? "Maior que:" : "Menor que:" : null
                        },
                        {
                          label: "Intervalo Entre Compras",
                          value:
                            cohort.intervalo_entre_compras === null
                              ? null
                              : cohort.intervalo_entre_compras,
                          condition: cohort.condition_intervalo_entre_compras ? cohort.condition_intervalo_entre_compras === "greater" ? "Maior que:" : "Menor que:" : null
                        },
                        {
                          label: "Black List",
                          value:
                            cohort.black_list === null
                              ? null
                              : cohort.black_list === true
                                ? "Sim"
                                : "Não",
                        },
                        {
                          label: "Valor Saldo",
                          value: cohort.valor_saldo ? FormatCurrency(cohort.valor_saldo) : null,
                          condition: cohort.condition_valor_saldo ? cohort.condition_valor_saldo === "greater" ? "Maior que:" : "Menor que:" : null
                        },
                        {
                          label: "Cadastro Proposta",
                          value: cohort.cadastro_proposta ? FormatDate(cohort.cadastro_proposta) : null,
                          condition: cohort.condition_cadastro_proposta ? cohort.condition_cadastro_proposta === "greater" ? "Maior que:" : "Menor que:" : null
                        },
                        {
                          label: "Data Última Compra",
                          value: cohort.data_ultima_compra ? FormatDate(cohort.data_ultima_compra) : null,
                          condition: cohort.condition_data_ultima_compra ? cohort.condition_data_ultima_compra === "greater" ? "Maior que:" : "Menor que:" : null
                        },
                        {
                          label: "Data Aniversário",
                          value: cohort.data_aniversario ? `Mês: ${cohort.data_aniversario}` : null,
                            
                        },
                        {
                          label: "Data Última Consulta",
                          value: cohort.ultima_consulta ? FormatDate(cohort.ultima_consulta) : null,
                          condition: cohort.condition_ultima_consulta ? cohort.condition_ultima_consulta === "greater" ? "Maior que:" : "Menor que:" : null
                        },
                        {
                          label: "Autorizado QI",
                          value: cohort.autorizado_qi === null ? null : cohort.autorizado_qi === true ? "Sim" : "Não"
                        },
                        {
                          label: "Autorizado Facta",
                          value: cohort.autorizado_facta === null ? null : cohort.autorizado_facta === true ? "Sim" : "Não"
                        },
                        {
                          label: "Autorizado UY3",
                          value: cohort.autorizado_uy3 === null ? null : cohort.autorizado_uy3 === true ? "Sim" : "Não"
                        },
                        {
                          label: "Autorizado BMP",
                          value: cohort.autorizado_bmp === null ? null : cohort.autorizado_bmp === true ? "Sim" : "Não"
                        },
                        {
                          label: "Fase",
                          value: cohort.hist_avancado?.fase || null,
                        },
                        {
                          label: "Data de Consulta",
                          value: cohort.hist_avancado?.data_consulta
                            ? cohort.hist_avancado.data_consulta
                              .split(' - ')
                              .map(date => FormatDate(date))
                              .join(' até ')
                            : null,
                        },
                        {
                          label: "Data de Cadastro",
                          value: cohort.hist_avancado?.data_cadastro
                            ? cohort.hist_avancado.data_cadastro
                              .split(' - ')
                              .map(date => FormatDate(date))
                              .join(' até ')
                            : null,
                        },
                        {
                          label: "Agente",
                          value: cohort.agente || null,
                        }

                      ];

                      return (
                        <div
                          key={cohort.id}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "1rem",
                            borderBottom: "1px solid #ddd",
                          }}
                        >
                          <div onClick={() => cohort?.id && handleCohortById(cohort.id)} style={{ cursor: "pointer" }}>
                            <p style={{ margin: 0, fontWeight: "500", fontSize: "1.2rem" }}>
                              <strong>Tag: </strong> {cohort.tag}
                            </p>
                            <div className="d-flex justify-content-between gap-3">
                              {atributos
                                .filter((attr) => attr.value !== null && attr.value !== undefined)
                                .map((attr, index) => (
                                  <div
                                    key={index}
                                    className="d-flex flex-column"
                                    style={{ margin: 0, fontWeight: "500", fontSize: "0.7rem" }}
                                  >
                                    <strong>{attr.label}: </strong>
                                    <div>{attr.condition} {attr.value}</div>
                                  </div>
                                ))}
                            </div>
                          </div>
                          <div style={{ display: "flex", gap: "0.35rem" }}>
                            <FaEdit style={{ cursor: "pointer" }} onClick={() => navigate(`/cohortsUpdate/${cohort.id}`)} />
                            <FaTrash style={{ cursor: "pointer" }} onClick={() => deleteModal(cohort)} />
                          </div>
                          {(cohort.id !== undefined && cohortToastedId === cohort.id.toString()) && (success || error) && (

                            <ToasterAdviser
                              type={success ? "success" : "error"}
                              message={success || error}
                              icon={success ? "success" : "error"}
                            />)}
                        </div>

                      );
                    })
                  ) : (
                    <p style={{ color: "red", marginTop: "1rem" }}>Nenhum cohort encontrado.</p>
                  )}
                </div>
              )}
            </Col>
          </div>
        </div>

        {/* Modal de confirmação de exclusão */}
        <Modal isOpen={confirmDelete} toggle={() => setConfirmDelete(false)}>
          <ModalHeader toggle={() => setConfirmDelete(false)}>Confirmar Exclusão</ModalHeader>
          <ModalBody>
            Você tem certeza que deseja excluir o cohort tag: {selectedCohort?.tag}
          </ModalBody>
          <ModalFooter>
            <Button
              className="cohort_create_button"
              onClick={() => {
                if (selectedCohort) {
                  handleDelete(selectedCohort.id!)
                }
                setConfirmDelete(false);
              }}
            >
              Confirmar
            </Button>{" "}
            <Button color="secondary" onClick={() => setConfirmDelete(false)}>
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
      </>
    </MainContainer>
  );
};
